import { render, staticRenderFns } from "./taikang.vue?vue&type=template&id=4446f6b1&scoped=true&"
import script from "./taikang.vue?vue&type=script&lang=js&"
export * from "./taikang.vue?vue&type=script&lang=js&"
import style0 from "./taikang.vue?vue&type=style&index=0&id=4446f6b1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.6@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4446f6b1",
  null
  
)

export default component.exports